export interface EmbeddedLinkModel {
  id: number;
  url: string;
  totalClicks: number;
  totalUniqueClicks: number;
}
